export default __webpack_public_path__ + "static/media/uploader-oneTouchUltraMini-problem-1.270354cd.png";